import { createFileRoute } from '@tanstack/react-router'

import { DevicePairingPage } from '#components/features/auth/device-pairing-page'

export const Route = createFileRoute('/parear-dispositivo')({
  head: () => ({
    meta: [
      { title: 'Parear dispositivo | UseComanda' },
      {
        name: 'description',
        content: 'Vincule este dispositivo ao seu estabelecimento.',
      },
    ],
  }),
  component: DevicePairingPage,
})
